<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <rect fill="currentColor" x="7.5" y="7" width="3" height="10" rx="1"></rect>
    <rect fill="currentColor" x="13.5" y="7" width="3" height="10" rx="1"></rect>
</svg>
